import React, { useEffect, useState } from "react";
import {
	Container,
	Row,
	Col,
	Card,
	Table,
	Button,
	Badge,
} from "react-bootstrap";
import LeftAd from "../Ads/LeftAd";
import MobileAd from "../Ads/MobileAd";
import RightAd from "../Ads/RightAd";
import TopAd from "../Ads/TopAd";
import HomeTopRow from "../HomePage/components/HomeTopRow";
import { getEvents } from "../../services/eventService";
import { FaGlobe } from "react-icons/fa";

const Watch = () => {
	const [events, setEvents] = useState([]);
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		fetchEvents();
	}, []);

	const fetchEvents = async () => {
		try {
			const res = await getEvents();
			setEvents(res.data);
		} catch (error) {
			console.error("Error fetching events:", error);
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	// Broadcast data
	const watchData = [
		{
			region: "North America",
			countries: [
				{ name: "Canada", providers: ["Flosports"] },
				{ name: "USA", providers: ["Max"] },
			],
		},
		{
			region: "Central and South America",
			countries: [
				{ name: "Brazil", providers: ["Rede Minas", "Bandsport"] },
				{ name: "Puerto Rico", providers: ["Max"] },
				{ name: "All other territories", providers: ["MTBWS TV"] },
			],
		},
		{
			region: "Asia",
			countries: [
				{
					name: "Indonesia, Macao, Malaysia, Mongolia, Singapore, South Korea, Thailand",
					providers: ["Eurosport"],
				},
				{ name: "All other territories", providers: ["MTBWS TV"] },
			],
		},
		{
			region: "Oceania",
			countries: [
				{ name: "Australia", providers: ["Stan Sport"] },
				{ name: "New Zealand", providers: ["MTBWS TV"] },
			],
		},
		{
			region: "Africa",
			countries: [
				{
					name: "South Africa and other African nations",
					providers: ["Supersport"],
				},
				{ name: "All other territories", providers: ["MTBWS TV"] },
			],
		},
		{
			region: "Europe",
			countries: [
				{ name: "United Kingdom", providers: ["discovery+", "TNT Sports"] },
				{
					name: "France",
					providers: ["Max", "Eurosport", "L'Équipe (XCO live + XCC delayed)"],
				},
				{ name: "Germany", providers: ["discovery+", "Eurosport"] },
				{ name: "Switzerland", providers: ["Eurosport", "SRF/RSI"] },
				{
					name: "Most other European countries",
					providers: ["Max", "Eurosport"],
				},
				{ name: "All other territories", providers: ["MTBWS TV"] },
			],
		},
	];

	return (
		<Container className=" text-light">
			{/* <Row className="m-0 p-0">{isMobile ? <MobileAd /> : <TopAd />} </Row> */}
			{/* Row of Events */}

			<Card className="bg-dark text-light border-0 mt-3">
				<Card.Body>
					<Card.Title className="text-start fs-2 text-info fw-bold">
						WHERE TO WATCH
					</Card.Title>
					<div className="my-4 p-3 bg-secondary bg-opacity-10 rounded">
						<h5 className="text-warning">New for 2025</h5>
						<p>
							Warner Bros. Discovery has launched MTBWS TV for viewers in
							territories without existing broadcast partnerships. Available as
							a subscription service through Staylive.
						</p>
						<p className="mt-3 fst-italic">
							<Badge bg="success" className="me-2">
								Free Option
							</Badge>
							Race highlights will be available after the events on the UCI MTB
							World Series YouTube channel.
						</p>
					</div>

					{watchData.map((region, index) => (
						<Card key={index} className="mb-4 bg-dark border border-secondary">
							<Card.Header className="bg-dark bg-opacity-75 text-white fs-5 fw-bold">
								<FaGlobe className="mb-1 me-1" />{" "}
								{region.region.toLocaleUpperCase()}
							</Card.Header>
							<Card.Body className="p-0">
								<Table striped hover variant="dark" responsive className="mb-0">
									<thead>
										<tr>
											<th style={{ width: "50%" }}>Location</th>
											<th style={{ width: "50%" }}>Broadcast Provider</th>
										</tr>
									</thead>
									<tbody>
										{region.countries.map((country, cIndex) => (
											<tr key={cIndex}>
												<td>{country.name}</td>
												<td>
													{country.providers.map((provider, pIndex) => (
														<span key={pIndex} className="me-1">
															{provider}
															{pIndex < country.providers.length - 1
																? " • "
																: ""}
														</span>
													))}
												</td>
											</tr>
										))}
									</tbody>
								</Table>
							</Card.Body>
						</Card>
					))}

					<div className="text-center mt-4 mb-2 text-muted small">
						<em>
							Broadcast information is accurate as of the beginning of the 2025
							World Cup series and subject to change throughout the season.
						</em>
					</div>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default Watch;
